import React, { useState } from 'react';
import Button from '../components/elements/button';
import FormInput from '../components/elements/form_input';
import { Facebook, Instagram, Linkedin, Mail, Phone, YouTube } from '../assets/icons';
import '../assets/css/pages/contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            // Handle form submission
            // Simulate API call
            await new Promise(resolve => setTimeout(resolve, 1000));
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="contact-page">
            <div className="contact-container">
                {/* Left Column */}
                <div className="contact-info">
                    <h1>Get in Touch</h1>
                    <p className="contact-description">
                        Have questions about our services? Reach out to us and we'll get back to you as soon as possible.
                    </p>

                    <div className="contact-details">
                        <div className="contact-item">
                            <img src={Phone} alt="" className="contact-icon" />
                            <p>+234 707 353 4714</p>
                            {/* <p>+234 813 055 5438</p> */}
                        </div>
                        <div className="contact-item">
                            <img src={Mail} alt="" className="contact-icon" />
                            <p>eaquahealth126@gmail.com</p>
                        </div>
                    </div>

                    <div className="social-links">
                        <h3>Follow Us</h3>
                        <div className="social-icons">
                            <a href="https://www.facebook.com/profile.php?id=61578036872635"><img src={Facebook} alt="Facebook" /></a>
                            <a href="https://instagram.com/eaquahealth"><img src={Instagram} alt="Instagram" /></a>
                            <a href="https://www.linkedin.com/in/e-aqua-health-292779383"><img src={Linkedin} alt="LinkedIn" /></a>
                            <a href="https://youtube.com/@eaquahealth"><img src={YouTube} alt="YouTube" /></a>
                        </div>
                    </div>
                </div>

                {/* Right Column */}
                <div className="contact-form-container">
                    <form onSubmit={handleSubmit} className="contact-form">
                        <FormInput
                            label="Name"
                            type="text"
                            name="name"
                            showLabel={true}
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                        <FormInput
                            label="Email"
                            type="email"
                            name="email"
                            showLabel={true}
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                        <FormInput
                            label="Subject"
                            type="text"
                            name="subject"
                            showLabel={true}
                            value={formData.subject}
                            onChange={handleChange}
                            required
                        />
                        <div className="form-input-container">
                            <label>Message</label>
                            <textarea
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                rows="5"
                            />
                        </div>
                        <div className="form-action">
                            <Button
                                text={isLoading ? "Sending..." : "Send Message"}
                                type="submit"
                                variant="primary"
                                loading={isLoading}
                                disabled={isLoading}
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;